import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)

let default_lang = 'pt';

// localStorage.removeItem('lang');
if(localStorage.getItem('lang') === null) {
  localStorage.setItem('lang', default_lang);
}

Vue.component(
  'Footer', 
  () => import(/* webpackChunkName: "footer" */ './components/Footer.vue')
);

export default new Router({
  // mode: 'history',
  scrollBehavior: function(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 400)
    })
  },
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes: [
    {
      path: '/',
      redirect: '/' +localStorage.lang,
    },
    {
      path: '/:lang',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/',
          name: 'home',
          meta: {
            has_nav_effect: true,
            title: 'Sonagi | Home'
          },
          component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
          path: 'about',
          name: 'about',
          meta: {
            has_nav_effect: false,
            title: 'Sonagi | About'
          },
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: 'portfolio/:type',
          name: 'portfolio',
          meta: {
            has_nav_effect: false,
            title: 'Sonagi | Portfolio'
          },
          component: () => import(/* webpackChunkName: "portfolio" */ './views/Portfolio.vue')
        },
        {
          path: 'investors',
          name: 'investors',
          meta: {
            has_nav_effect: false,
            title: 'Sonagi | Investors'
          },
          component: () => import(/* webpackChunkName: "investors" */ './views/Investors.vue')
        },
        {
          path: 'contacts',
          name: 'contacts',
          meta: {
            has_nav_effect: false,
            has_map: true,
            title: 'Sonagi | Contacts'
          },
          component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
        },
        {
          path: 'project/:id/:slug',
          name: 'project',
          meta: {
            has_nav_effect: false,
            title: 'Sonagi | '
          },
          component: () => import(/* webpackChunkName: "contacts" */ './views/Project.vue')
        },
        {
          path: 'privacy-policy',
          name: 'privacy_policy',
          meta: {
            has_nav_effect: false,
            title: 'Sonagi | Privacy Policy'
          },
          component: () => import(/* webpackChunkName: "contacts" */ './views/PrivacyPolicy.vue')
        },
        {
          path: '*',
          name: 'error_404',
          redirect: '/' +localStorage.lang,
          // alias: '*',
          meta: {
            has_nav_effect: false,
            title: 'Sonagi | Error 404'
          },
          component: () => import(/* webpackChunkName: "home" */ './views/errors/Error_404.vue')
        },
      ],
    },
    /*{
      path: '*',
      redirect: '/' +localStorage.lang+ '/404',
    },*/
  ]
})
